import React from 'react';
import {
  Box,
  Typography,
  LinearProgress,
  Paper,
  Tooltip,
  useTheme
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const UsageLimits = ({ 
  title, 
  used, 
  limit, 
  tooltip,
  showPercentage = true,
  barColor = null,
  variant = 'standard' // standard or compact
}) => {
  const theme = useTheme();
  const percentage = limit > 0 ? Math.min(100, (used / limit) * 100) : 0;
  
  // Determine color based on usage percentage
  const getBarColor = () => {
    if (barColor) return barColor;
    
    if (percentage < 70) return theme.palette.success.main;
    if (percentage < 90) return theme.palette.warning.main;
    return theme.palette.error.main;
  };

  return (
    <Paper 
      elevation={variant === 'compact' ? 0 : 1} 
      sx={{ 
        p: variant === 'compact' ? 1 : 2,
        mb: variant === 'compact' ? 0.5 : 2,
        borderRadius: 1,
        backgroundColor: variant === 'compact' ? 'transparent' : theme.palette.background.paper
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
        <Typography variant={variant === 'compact' ? 'body2' : 'subtitle1'} fontWeight="medium">
          {title}
        </Typography>
        
        {tooltip && (
          <Tooltip title={tooltip} arrow placement="top">
            <InfoIcon 
              fontSize="small" 
              color="action" 
              sx={{ ml: 0.5, height: variant === 'compact' ? 16 : 20 }} 
            />
          </Tooltip>
        )}
        
        <Box sx={{ ml: 'auto' }}>
          <Typography variant={variant === 'compact' ? 'body2' : 'body1'} fontWeight="medium">
            {used} / {limit}
            {showPercentage && (
              <Typography 
                component="span" 
                variant={variant === 'compact' ? 'caption' : 'body2'} 
                color="text.secondary"
                sx={{ ml: 1 }}
              >
                ({Math.round(percentage)}%)
              </Typography>
            )}
          </Typography>
        </Box>
      </Box>
      
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: variant === 'compact' ? 4 : 6,
          borderRadius: 5,
          backgroundColor: theme.palette.grey[200],
          '& .MuiLinearProgress-bar': {
            backgroundColor: getBarColor()
          }
        }}
      />
    </Paper>
  );
};

export default UsageLimits; 